var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 2.875H6C6.06875 2.875 6.125 2.81875 6.125 2.75V2.875H10.875V2.75C10.875 2.81875 10.9312 2.875 11 2.875H10.875V4H12V2.75C12 2.19844 11.5516 1.75 11 1.75H6C5.44844 1.75 5 2.19844 5 2.75V4H6.125V2.875ZM14 4H3C2.72344 4 2.5 4.22344 2.5 4.5V5C2.5 5.06875 2.55625 5.125 2.625 5.125H3.56875L3.95469 13.2969C3.97969 13.8297 4.42031 14.25 4.95312 14.25H12.0469C12.5813 14.25 13.0203 13.8313 13.0453 13.2969L13.4312 5.125H14.375C14.4438 5.125 14.5 5.06875 14.5 5V4.5C14.5 4.22344 14.2766 4 14 4ZM11.9266 13.125H5.07344L4.69531 5.125H12.3047L11.9266 13.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.642af7a3743f241e78586197efe1ac5a.svg";
export { ForwardRef as ReactComponent };